class Expandable extends HTMLElement {
  constructor() {
    super();
    this.element = this.querySelector('.expandable');
    this.content = this.querySelector('.expandable__content');
    
    this.element.addEventListener('click', () => {
      if(this.element.classList.contains('active')) {
        this.element.classList.remove('active')
        this.content.style.maxHeight = `0px`
        typeof studioScroll != 'undefined' && studioScroll.updateHeight(0);
      } else {
        $('.expandable.active').removeClass('active')
        $('.expandable__content').css('max-height', '0px')
        this.element.classList.add('active')
        this.content.style.maxHeight = `${this.content.scrollHeight}px`  
        typeof studioScroll != 'undefined' && studioScroll.updateHeight(this.content.scrollHeight);
      }

    })

  }
}

customElements.define('expandable-content', Expandable);